import { googleActions } from '../../../actions'

/**
 * Kullanıcının sistemde var olan bir Google hesabını yeniden eklemek isteyip
 * istemediğini kontrol eden servis metodu.
 * 
 * @param {string} email - Kontrol edilecek Google hesabı e-posta adresi
 * @returns {Promise<boolean>} - İlgili hesap zaten mevcut mu
 */
export const checkDuplicateAccount = async (email) => {
  try {
    if (!email || typeof email !== 'string') {
      console.error('checkDuplicateAccount: Invalid email parameter');
      return false;
    }
    
    // Hesabın zaten mevcut olup olmadığını kontrol et
    return await googleActions.checkDuplicateAccount(email);
  } catch (error) {
    console.error('checkDuplicateAccount service error:', error);
    return false;
  }
};